import { CountryData2024, CountryData2025 } from '@models/Country'
import { dataVersions } from '@utils/data'

export const V2024 = '2024'
export const V2025 = '2025'
export const DEFAULT_VERSION: VersionYear = dataVersions.length ? dataVersions[0].year : V2024
export type VersionYear = '2024' | '2025'

export const VersionStorage = 'v20250505'

export interface Version {
  year: VersionYear
  label: string
  file: string
  documentId: string
  validFrom: string
  validUntil: string
  countries: CountryData2024[] | CountryData2025[]
}
